import { useCallback, useEffect, useMemo, useState } from "react";

export function useAsyncFetch<T>(url: string, headers: HeadersInit, method: string) {
  const [requestState, setRequestState] = useState<"initial" | "loading" | "error" | "done">("initial");
  const [errorState, setErrorState] = useState<string | undefined>();
  const [responseState, setResponseState] = useState<T | undefined>(undefined);
  const callback = useCallback(async () => {
    try {
      setRequestState("loading");
      const response = await fetch(url, {
        headers: headers,
        method: method,
      });
      if (!response.ok) {
        setRequestState("error");
        throw new Error("error!");
      }
      const jsonResp = await response.json();
      setRequestState("done");
      setResponseState(jsonResp as T);
    } catch (e) {
      setRequestState("error");
      setErrorState("An error occurred");
    }
  }, [url, headers, method]);
  useEffect(() => {
    callback();
  }, [callback]);
  return {
    loading: requestState === "loading",
    error: errorState,
    state: requestState,
    data: requestState === "loading" || requestState === "initial" ? undefined : responseState,
  };
}
